<template>
  <v-app-bar
      absolute
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      dark
      :collapse="!collapseOnScroll"
      :collapse-on-scroll="collapseOnScroll"
      scroll-target="#container-profiles"
      id="filtering-search"
      :class="[$vuetify.breakpoint.lgAndUp ? '' : ($vuetify.breakpoint.md ? 'medium' : ($vuetify.breakpoint.sm ? 'small' : 'xsmall'))]"
  >

    <v-checkbox
        v-model="collapseOnScroll"
        color="white"
        hide-details
    ></v-checkbox>

    <v-spacer></v-spacer>

    <v-container v-show="collapseOnScroll">
      <v-row class="mx-5 pt-3">
        <v-col
            cols="12"
            md="4"
        >
          <v-text-field
              v-model="username"
              label="Nombre de usuario"
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            md="4"
        >
          <v-text-field
              v-model="phoneNumber"
              :counter="9"
              label="Teléfono"
          ></v-text-field>
        </v-col>

        <v-col class="pt-7">
          <v-switch
              v-model="online"
              color="green"
              :label="`Online: ${online.toString()}`"
              disabled
          ></v-switch>
        </v-col>
      </v-row>

      <v-spacer></v-spacer>

      <v-row class="mx-5">

        <v-col class="col-lg-4 col-md-6 col-sm-12 px-4">
          <v-subheader class="px-0">Rango de edad: Ellos</v-subheader>
          <v-spacer></v-spacer>
          <v-range-slider
              v-model="rangeMen"
              :max="max"
              :min="min"
              hide-details
              class="align-center"
          >
            <template v-slot:prepend>
              <v-text-field
                  :value="rangeMen[0]"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  type="number"
                  style="width: 60px"
                  @change="$set(rangeMen, 0, $event)"
              ></v-text-field>
            </template>
            <template v-slot:append>
              <v-text-field
                  :value="rangeMen[1]"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  type="number"
                  style="width: 60px"
                  @change="$set(rangeMen, 1, $event)"
              ></v-text-field>
            </template>
          </v-range-slider>
        </v-col>

        <v-col class="col-lg-4 col-md-6 col-sm-12 px-4">
          <v-subheader class="px-0">Rango de edad: Ellas</v-subheader>
          <v-spacer></v-spacer>
          <v-range-slider
              v-model="rangeWomen"
              :max="max"
              :min="min"
              hide-details
              class="align-center"
          >
            <template v-slot:prepend>
              <v-text-field
                  :value="rangeWomen[0]"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  type="number"
                  style="width: 60px"
                  @change="$set(rangeWomen, 0, $event)"
              ></v-text-field>
            </template>
            <template v-slot:append>
              <v-text-field
                  :value="rangeWomen[1]"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  type="number"
                  style="width: 60px"
                  @change="$set(rangeWomen, 1, $event)"
              ></v-text-field>
            </template>
          </v-range-slider>
        </v-col>

        <v-col class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 px-4">
          <v-radio-group
              v-model="type"
              row
          >
            <v-row class="px-2 col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
              <v-radio class="mx-0 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 px-0"
                  label="Tod@s"
                  value="todos"
              ></v-radio>

              <v-radio class="mx-0 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 px-0"
                  label="Parejas"
                  value="pareja"
              ></v-radio>
            </v-row>

            <v-row
                :class="[$vuetify.breakpoint.mdAndDown ? 'px-2 col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12 mt-n3' : 'px-2 col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12']"
            >
              <v-radio class="mx-0 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 px-0"
                  label="Triejas"
                  value="trieja"
              ></v-radio>

              <v-radio class="mx-0 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 px-0"
                  label="Solos"
                  value="solo"
              ></v-radio>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-spacer></v-spacer>

      <v-row class="mx-5">
        <v-col class="px-4">
          <v-subheader class="px-0">Ellos:</v-subheader>

          <v-radio-group
              v-model="men"
              row
          >
            <v-row class="px-2 col-12">
              <v-radio class="col-md-6 col-sm-12 mx-0 px-0"
                       label="Heterosexual"
                       value="Heterosexual"
              ></v-radio>

              <v-radio class="col-md-6 col-sm-12 mx-0 px-0"
                       label="Bisexual"
                       value="Bisexual"
              ></v-radio>
            </v-row>

          </v-radio-group>
        </v-col>

        <v-col class="px-4">
          <v-subheader class="px-0">Ellas:</v-subheader>

          <v-radio-group
              v-model="women"
              row
          >
            <v-row class="px-2 col-12">
              <v-radio class="col-md-6 col-sm-12 mx-0 px-0"
                       label="Heterosexual"
                       value="Heterosexual"
              ></v-radio>

              <v-radio class="col-md-6 col-sm-12 mx-0 px-0"
                       label="Bisexual"
                       value="Bisexual"
              ></v-radio>
            </v-row>

          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>

    <v-btn icon v-show="collapseOnScroll" @click="filterSearch">
      <v-icon>mdi-magnify</v-icon>
    </v-btn>

  </v-app-bar>
</template>

<script>
import EventBus from "../EventBus.js"
import FiltersStorage from "@/services/FiltersStorage"

export default {
  data: () => ({
    collapseOnScroll: false,
    username: '',
    phoneNumber: '',
    online: false,
    type: 'todos',
    men: 'Heterosexual',
    women: 'Heterosexual',
    min: 18,
    max: 80,
    rangeMen: [25, 60],
    rangeWomen: [25, 60],
    filters: {}
  }),
  methods: {
    filterSearch(){

      if (this.username !== '') {
        this.filters['username'] = this.username
      } else {
        this.filters['username'] = ''
      }

      if (this.phoneNumber !== '') {
        this.filters['telephone'] = this.phoneNumber
      } else {
        this.filters['telephone'] = ''
      }

      if (this.online === true) {
        // filters['online'] = true
        // TODO:filtering for next version
      }
      if (this.type !== '' && ['pareja', 'trieja', 'solo'].indexOf(this.type) > -1) {
        this.filters['type'] = this.type
      } else if (this.type === 'todos') {
        this.filters['type'] = ''
      }

      if (this.men !== '' && ['Heterosexual','Bisexual'].indexOf(this.men) > -1) {
        this.filters['men'] = this.men
      } else if (this.men === '') {
        this.filters['men'] = ''
      }

      if (this.women !== '' && ['Heterosexual','Bisexual'].indexOf(this.women) > -1) {
        this.filters['women'] = this.women
      } else if (this.women === '') {
        this.filters['women'] = ''
      }

      this.filters['rangeMen'] = this.rangeMen
      this.filters['rangeWomen'] = this.rangeWomen

      EventBus.$emit("filterParameters", this.filters)
    },
    setFilters(){
      this.username = this.filters['username']
      this.phoneNumber = this.filters['telephone']
      this.type = this.filters['type']
      this.men = this.filters['men']
      this.women = this.filters['women']
      this.rangeMen = this.filters['rangeMen']
      this.rangeWomen = this.filters['rangeWomen']
    }
  },
  created (){
    if (FiltersStorage.hasFiltersStored()) {
      this.filters = FiltersStorage.getFilters();
      this.setFilters()
    }
  },
  components: { }
}
</script>
<!-- These styles are generated on the fly that is why it's showing as they are not in use in the code -->
<style type="text/css">
#filtering-search.v-toolbar:not(.v-toolbar--collapsed){
  height:350px !important;
}
#filtering-search.v-toolbar.medium:not(.v-toolbar--collapsed){
  height:420px !important;
}
#filtering-search.v-toolbar.small:not(.v-toolbar--collapsed){
  height:720px !important;
}
#filtering-search.v-toolbar.xsmall:not(.v-toolbar--collapsed){
  height:950px !important;
}
#filtering-search.v-toolbar.v-toolbar--collapsed {
  justify-content: center;
  overflow: hidden;
  width:54px;
}
</style>